module.exports = __webpack_public_path__ + "static/media/interaction-toggle-checkmark-multi-select-off.1da208c6.svg";